module.exports = __webpack_public_path__ + "static/media/wave_hand_emoji.d94c1d7b.svg";